import { TrendingUp, Briefcase, Building2, DollarSign, Sparkles, Activity } from "lucide-react";

export default function RankIcon({ iconKey, color, size=14 }) {
  const props = { size, color, strokeWidth:2 };
  if (iconKey==="trending-up")  return <TrendingUp {...props}/>;
  if (iconKey==="briefcase")    return <Briefcase {...props}/>;
  if (iconKey==="building2")    return <Building2 {...props}/>;
  if (iconKey==="dollar-sign")  return <DollarSign {...props}/>;
  if (iconKey==="sparkles")     return <Sparkles {...props}/>;
  return <Activity {...props}/>;
}
